import React from "react";
import AppointmentForm from "../Components/AppointmentForm";
import Footer from "../Components/Footer";

function Appointment() {
  return (
    <>
      <AppointmentForm />
      <Footer />
    </>
  );
}

export default Appointment;
